module.exports = __webpack_public_path__ + "img/19.a2649656.jpg";